// รายการหัวข้อการพัฒนา (เดิมซ้ำกัน 3 จุด: EvaluateForm tab4 x1, EditEvaluateForm tab4 x2)
// value/label เหมือนต้นฉบับทุกประการ ห้ามแก้ลำดับหรือค่า value
export const DEVELOPMENT_TOPICS = [
  { value: 1, label: "ด้านการมุ่งผลสัมฤทธิ์" },
  { value: 2, label: "ด้านการบริการที่ดี" },
  { value: 3, label: "ด้านการสั่งสมความเชี่ยวชาญในอาชีพ" },
  { value: 4, label: "ด้านการยึดมั่นในความถูกต้องชอบธรรมและจริยธรรม" },
  { value: 5, label: "ด้านการทำงานเป็นทีม" },
  { value: 6, label: "ด้านเทคโนโลยีสารสนเทศ" },
  { value: 7, label: "ด้านภาษา" },
  { value: 8, label: "ด้านการบริหารจัดการ" },
  { value: 9, label: "ด้านการวิเคราะห์ การจัดทำข้อมูล" },
  { value: 10, label: "ด้านการพัฒนานวัตกรรม" },
  { value: 11, label: "ด้านการสื่อสาร" },
  { value: 12, label: "อื่นๆ" },
];
